import { CSSProperties } from 'react';

import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import { MorphIcon } from 'morphicons/react';
import { Backpack, BookOpen, Building2, Library, School, type IconNode } from 'lucide';

type Props = { style?: CSSProperties; type?: string };

const ICON_BY_TYPE: Record<string, IconNode> = {
  TH: School,
  THCS: Library,
  THPT: BookOpen,
  PTCS: Backpack,
  MN: School,
  HVS: Building2,
};

/**
 * Ô icon trường: nét stroke (morphicons + lucide), nền nhạt theo màu chủ đạo.
 * Mỗi cấp một icon, không dùng mũ cử nhân. Giữ `style` như SVG cũ.
 */
const SchoolTile = ({ style, type }: Props) => (
  <Box
    style={style}
    sx={{
      aspectRatio: '1 / 1',
      flexShrink: 0,
      alignSelf: 'center',
      borderRadius: '30%',
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
      color: 'primary.main',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: (theme) => `inset 0 0 0 1px ${alpha(theme.palette.primary.main, 0.14)}`,
    }}
  >
    <MorphIcon
      icon={ICON_BY_TYPE[type ?? ''] ?? School}
      size={22}
      strokeWidth={1.75}
      absoluteStrokeWidth
      color="currentColor"
      reducedMotion="user"
    />
  </Box>
);

export default SchoolTile;
